import Cookies from '../services/cookies';
import { COOKIE_NAME_CURRENCY } from '../constants';
import localStorageCache from './cacheUtils';
import { updateLocationWithNewQueryStrings } from '../utils';

export const oneYearInSeconds = 365 * 24 * 60 * 60;

/**
 * Change the site's currency setting by updating the urbn_currency cookie
 * and optionally updating the URL with a cache buster query param for the new currency
 * @param  {String}  newCurrency the new currency
 * @param  {Number}  expiration  expiration of new currency cookie (in seconds) (defaults to 1 year)
 * @param  {Boolean} updateURL   update the URL to reflect the currency change? (defaults to true)
 * @return {undefined}
 */
export function changeCurrency(newCurrency, expiration = oneYearInSeconds, updateURL = true) {
    Cookies.setCookie(COOKIE_NAME_CURRENCY, newCurrency, expiration);
    localStorageCache.clear();

    if (updateURL) {
        // Forcing browser to bust cache
        updateLocationWithNewQueryStrings({ 'currency': newCurrency });
    }
}
